import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import NewSimulation from "@/pages/NewSimulation";
import SimulationResult from "@/pages/SimulationResult";
import History from "@/pages/History";
import { Toaster } from "@/components/ui/sonner";
import "@/i18n";

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback (session_id in URL fragment) before normal routing
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/new" element={<ProtectedRoute><NewSimulation /></ProtectedRoute>} />
      <Route path="/simulation/:id" element={<ProtectedRoute><SimulationResult /></ProtectedRoute>} />
      <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" theme="dark" />
      </BrowserRouter>
    </AuthProvider>
  );
}
